import { InfoOutlinedIcon, makeStyles, Theme, Tooltip } from '@freighthub/silhouette-core'
import { FC } from 'react'

export const testIds = { delayInfoIcon: 'delay_info_icon' }

const useStyles = makeStyles<Theme>((theme) => ({
  tooltip: { fontSize: theme.typography.body2.fontSize, zIndex: 9999, position: 'relative' },
  icon: { fontSize: theme.typography.body2.fontSize, zIndex: 9999, position: 'relative' },
}))

interface DelayInfoIconProps {
  tooltip: string
}

export const DelayInfoIcon: FC<DelayInfoIconProps> = (props) => {
  const classes = useStyles()
  return (
    <Tooltip title={props.tooltip} placement="top" classes={{ tooltip: classes.tooltip }}>
      <span>
        <InfoOutlinedIcon data-testid={testIds.delayInfoIcon} classes={{ root: classes.icon }} />
      </span>
    </Tooltip>
  )
}
